import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Title } from 'shared/components/abstract/interactables';
import FormCard from 'shared/components/FormCard';
import { createBuilding } from 'shared/api/buildings';
import { useAuth, useNotification, useRequest } from 'shared/hooks';
import { VARIANTS, VLAN_DEFAULTS } from 'shared/constants';
import { viewPath } from 'shared/routes/building';
import BuildingInfo from './BuildingInfo';
import { validateBuildingData } from './BuildingView';

export default function BuildingCreator() {
  const { user } = useAuth();
  const { request, isLoading } = useRequest();
  const notification = useNotification();

  const [building, setBuilding] = useState({
    name: '',
    address_1: '',
    address_2: '',
    city: '',
    zip: '',
    state: null,
    notes: '',
    wug_link: '',
    service_type: null,
    auth_method: null,
    contract_start: new Date().toISOString(),
    contract_end: new Date().toISOString(),
    vlan_range_start: VLAN_DEFAULTS.defaultVlanStart,
    vlan_range_end: VLAN_DEFAULTS.defaultVlanEnd,
    updated_by: user.username,
    qos: {
      id: 0,
      description: '',
      name: '',
    },
    complex: {
      id: 0,
      name: '',
    },
    manager: {
      id: 0,
      name: '',
    },
  });

  if (building && building.id) {
    return (
      <Redirect
        to={`${viewPath}/${building.id}`}
      />
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (validateBuildingData(building, notification)) {
      const res = await request(createBuilding(building), 'Created new building');
      if (res) {
        setBuilding(res);
      }
    }
    return null;
  };

  return (
    <form onSubmit={submit}>
      <Title title="Create Building" />
      <FormCard>
        <Grid container size={12} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <BuildingInfo
            editEnabled
            building={building}
            updatedData={building}
            updateValue={(key, value) => setBuilding({ ...building, [key]: value })}
          />
          <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="submit"
              variant="contained"
              color={VARIANTS.primary}
              disabled={isLoading}
            >
              Create
            </Button>
          </Grid>
        </Grid>
      </FormCard>
    </form>
  );
}
